<template>
  <nav class="navbar-default navbar-fixed-top fixedheader">
    <div class="container-fluid">
      <div class="outerborder">
        <div class="row row-cols-lg-12 row-cols-md-12 row-cols-sm-12 rows-cols-12">
          <div class="col-lg-4 col-md-4 col-sm-4 col-12 sidebyside widthbanner">
            <img src="../assets/banner.png" class="imgbanner" />
          </div>
          <div
            class="col-lg-3 col-md-4 col-sm-4 col-9 offset-lg-5 offset-md-4 offset-sm-4 offset-3"
          >
            <div class="row">
              <img src="../assets/person.png" @click="profile()" class="imgperson pr-2" />
              <h6>Welcome , {{userName}} !</h6>
            </div>

            <div class="row">
              <div class="col small">
                {{userRole}}
                <img src="../assets/logout.png" @click="logout()" class="imglogout" />
              </div>
            </div>
            <div class="row">
              <div class="small">Last Logged in {{lastLogged | moment("MM/DD/YYYY,h:mm:ss a")}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
export default {
  data () {
    return {
      userName: this.$session.get('user_name'),
      userRole: this.$session.get('user_role_name'),
      lastLogged: this.$session.get('last_logged_in')
    }
  },
  methods: {
    profile: function () {
      this.$router.push('/profile')
    },
    logout: function () {
      // make a rest call to capture a logout for the user
      this.$session.clear()
      this.$session.destroy()
      sessionStorage.removeItem('JWT')
      sessionStorage.removeItem('USERID')
      sessionStorage.removeItem('LOGGEDIN')
      localStorage.removeItem('userPermissions')
      this.$router.push('/')
      document.onload = ''
      document.onmousemove = this.resetTimer
      document.onmousedown = this.resetTimer
      document.ontouchstart = this.resetTimer
      document.onclick = this.resetTimer
      document.onscroll = this.resetTimer
      document.onkeypress = this.resetTimer
    }
  },
  components: {}
}
</script>
<style scoped>
.outerborder {
  border: 1px solid;
  background-color: white;
}
.imgperson {
  width: 30px;
  height: 35%;
}
.imglogout {
  width: 22px;
  height: 65%;
  cursor: pointer;
  margin-left: 5px;
}
.imgbanner {
  width: 100%;
  height: 70%;
}

.fixedheader {
  position: fixed;
  width: 100%;
  right: 0px;
  z-index: 5;
}

@media screen and (min-width: 769px) and(max-width: 1100px) {
  .fixedheader {
    position: fixed;
    padding: 0px 47px 0px 0px !important;
  }
}

@media screen and (min-width: 300px) and (max-width: 400px) {
  .fixedheader {
    position: fixed;
    padding: 0px 32px 0px 0px !important;
  }
}

@media screen and (min-width: 400px) and (max-width: 600px) {
  .fixedheader {
    padding: 0px 32px 0px 0px !important;
  }
}

@media screen and (min-width: 600px) and (max-width: 768px) {
  .fixedheader {
    position: fixed;
    padding: 0px 32px 0px 0px !important;
  }
}
</style>
